import { MenuButtonData } from '../../system/Classes/MenuButtonData';

export const mathMenuData: Array<MenuButtonData> = [
    {display:"課程目標", path:"/courseTarget/MathsObjectives"},
    {display:"校本課程特色", path:"/courseTarget/MathsBase"},
    {display:"年度重點項目", path:"/courseTarget/MathsConcern"},
    {display:"學生成果展示", path:"/courseTarget/MathsDisplay"},
    {display:"教師專業發展", path:"/courseTarget/MathsDevelopment"},
    {display:"網上學習資源", path:"/courseTarget/MathsResources"},
];